// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    
    

    /*
    render function
    */
    import { desCatalogCustomCellRenderFunction } from 'js/desCatalogCustomCellService';
    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/desCatalogCustomCellService', () => import('js/desCatalogCustomCellService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "actions": {
        "render": {
            "method": "desCatalogCustomCellRenderFunction",
            "deps": "js/desCatalogCustomCellService"
        }
    },
    "data": {},
    "conditions": {},
    "onEvent": [],
    "lifecycleHooks": {
        "render": "render"
    },
    "props": {
        "vmo": {
            "type": "object"
        }
    },
    "_viewModelId": "DesCatalogCustomCell",
    "_uniqueViewModelId": "DesCatalogCustomCell",
    "ctx": {}
};

    


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, desCatalogCustomCellRenderFunction, undefined, ctxImportObj );

    export default Component;